import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/departamentos';
import Departamento from './Departamento';


const ms2p = (state) => {
  return {
    ...state.departamento,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Departamento);
